/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Tag,
  TimePicker,
  Tooltip,
  Upload,
} from 'antd';

import { DeleteOutlined, ForkOutlined, UploadOutlined } from '@ant-design/icons';

import Utils from '../../../Assets/Scripts/Utils';
import CustomInstructorSelect from '../../../Components/Schedule/CustomInstructorSelect';
import { deleteFileFirebase, uploadFilesToFirebase } from '../API/TaskListApi';
import { getCellInitialValue } from '../Shared/TaskListFunctions';

import DriverVehicleCellEditor from './DriverVehicleCellEditor';

const { TextArea } = Input;

function readCustomFieldName(dataIndex, customFieldName) {
  if (customFieldName) {
    return customFieldName;
  }

  if (typeof dataIndex === 'string' && dataIndex.startsWith('customFields.')) {
    return dataIndex.slice('customFields.'.length);
  }

  return null;
}

function readCellFileList(record, dataIndex, isCustomField, customFieldName) {
  if (isCustomField) {
    const customFields = record?.customFields ?? record?.CustomFields ?? {};
    return customFields[customFieldName] ?? [];
  }

  return record?.[dataIndex] ?? [];
}

function resolveFormFieldName(dataIndex, isCustomField, customFieldName) {
  if (isCustomField) {
    return ['customFields', customFieldName];
  }

  return [dataIndex];
}

function ReasonNoBillingEditor({ value, onChange, options, title, disabled, onCommit }) {
  return (
    <Select
      value={value}
      placeholder={`Selecione ${title}`}
      optionFilterProp="label"
      dropdownStyle={{ borderRadius: 16, zIndex: 9999 }}
      options={options}
      showSearch
      allowClear
      disabled={disabled}
      style={{ width: '100%' }}
      onChange={async (nextValue) => {
        onChange?.(nextValue);
        if (!onCommit) return;

        const selected = options.find(
          (option) => option.id === nextValue || option.value === nextValue
        );
        const saved = await onCommit(selected ? { id: selected.id, name: selected.name } : null);
        if (saved === false) {
          onChange?.(value);
        }
      }}
    />
  );
}

function TrainingListFileEditor({ files, isCommitting, openForAllRoles, onDelete, onUpload }) {
  return (
    <div>
      {files.map((file, index) => (
        <Tag color="default" key={file.name || file.url || index}>
          <Popconfirm
            placement="topLeft"
            title="Tem certeza que deseja deletar o arquivo?"
            onConfirm={() => onDelete(file, index)}
            okText="Sim"
            okType="danger"
            cancelText="Cancelar"
          >
            <a style={{ color: 'red', marginLeft: 8 }}>
              <DeleteOutlined />
            </a>
          </Popconfirm>
          <a href={Utils.resolveBitrixDownloadUrl(file.url)} target="_blank" rel="noreferrer">
            <span style={{ marginLeft: 8, marginRight: 8 }}>
              {Utils.attachmentDownloadLabel(file)}
            </span>
          </a>
        </Tag>
      ))}
      {openForAllRoles && (
        <Upload multiple showUploadList={false} disabled={isCommitting} customRequest={onUpload}>
          <Button size="small" icon={<UploadOutlined />} disabled={isCommitting}>
            Incluir
          </Button>
        </Upload>
      )}
    </div>
  );
}

function propagateCellValue(
  formTaskList,
  record,
  dataIndex,
  inputType,
  isCustomField,
  customFieldName
) {
  if (inputType === 'fileUpload') {
    return;
  }

  const editingRows = formTaskList.getFieldsValue().list;
  if (isCustomField) {
    const currentValue = editingRows[record.tablePageIndex]?.customFields?.[customFieldName];
    editingRows.forEach((row) => {
      if (row) {
        row.customFields = { ...row.customFields, [customFieldName]: currentValue };
      }
    });
  } else {
    const currentRowData = editingRows[record.tablePageIndex][dataIndex];
    editingRows.forEach((row) => {
      if (row) {
        row[dataIndex] = currentRowData;
      }
    });
  }

  formTaskList.setFieldsValue({ list: editingRows });
}

export default function EditableCellComponent({
  record,
  title,
  inputType,
  dataIndex,
  editable,
  editing,
  attachDeleteEvent,
  children,
  fieldsPermissions,
  formTaskList,
  instructorOptions,
  driverOptions,
  vehicleOptions,
  reasonOptions,
  transportCompanyOptions,
  invoiceIssuersOptions,
  isCustomField,
  customFieldName,
  openForAllRoles,
  showPropagate,
  onCommitOpenField,
  ...restProps
}) {
  const [isCommitting, setIsCommitting] = useState(false);
  const transportFieldDataIndexes = [
    'transportCompany',
    'driverList',
    'boardingHour',
    'arrivalHour',
    'nfTransportation',
  ];

  const resolvedCustomName = readCustomFieldName(dataIndex, customFieldName);

  if (
    transportFieldDataIndexes.includes(dataIndex) &&
    record &&
    record.trainingTransportation !== 'Incluso'
  ) {
    return <td {...restProps}>-</td>;
  }

  if (!editable) {
    return <td {...restProps}>{children}</td>;
  }

  let fieldName = resolveFormFieldName(dataIndex, isCustomField, resolvedCustomName);
  let initialFieldName = fieldName;
  let additionalRules = null;

  const reasonNoBillingOptions = (reasonOptions || []).filter(({ type }) => type === 'NoBilling');

  let inputNode;
  switch (inputType) {
    case 'text':
      inputNode = <Input placeholder={`Preencha ${title}`} style={{ width: '100%' }} />;
      break;
    case 'textarea':
      inputNode = <TextArea rows={4} placeholder={`Preencha ${title}`} style={{ width: '100%' }} />;
      break;
    case 'email':
      additionalRules = {
        validator: Utils.validateEmails,
      };
      inputNode = (
        <Input placeholder="exemplo@email.com; exemplo2@email.com" style={{ width: '100%' }} />
      );
      break;
    case 'number':
      inputNode = <InputNumber placeholder="0" min={0} style={{ width: '100%' }} />;
      break;
    case 'currency':
      inputNode = (
        <InputNumber
          min={0}
          step={0.0001}
          formatter={Utils.priceFormatter}
          parser={Utils.priceParser}
          style={{ width: '100%' }}
          placeholder="o campo está vazio"
        />
      );
      break;
    case 'date':
      inputNode = <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />;
      break;
    case 'time':
      inputNode = <TimePicker format="HH:mm" style={{ width: '100%', borderRadius: 16 }} />;
      break;
    case 'dateTime':
      inputNode = <DatePicker showTime format="DD/MM/YYYY HH:mm" style={{ width: '100%' }} />;
      break;
    case 'checkbox':
      inputNode = <Checkbox />;
      break;
    case 'fileUpload':
      inputNode = (
        <TrainingListFileEditor
          files={readCellFileList(record, dataIndex, isCustomField, resolvedCustomName)}
          isCommitting={isCommitting}
          openForAllRoles={openForAllRoles}
          onDelete={async (file, index) => {
            if (openForAllRoles && onCommitOpenField) {
              setIsCommitting(true);
              try {
                const saved = await onCommitOpenField(record, { nfTrainingRemoveName: file.name });
                if (saved) {
                  await deleteFileFirebase(attachDeleteEvent, file.name, record);
                }
              } finally {
                setIsCommitting(false);
              }
              return;
            }

            const currentFiles = readCellFileList(
              record,
              dataIndex,
              isCustomField,
              resolvedCustomName
            );
            const target = currentFiles[index];
            target.shouldDelete = true;
            target.deleteEvent = attachDeleteEvent;
            currentFiles[index] = target;
          }}
          onUpload={async ({ file, onSuccess, onError }) => {
            setIsCommitting(true);
            try {
              const uploaded = await uploadFilesToFirebase(
                [{ name: file.name, originFileObj: file }],
                dataIndex,
                record.id
              );
              if (uploaded?.length && onCommitOpenField) {
                await onCommitOpenField(
                  record,
                  { nfTrainingAppend: uploaded },
                  'NFTrainingUploaded'
                );
              }
              onSuccess?.('ok');
            } catch (error) {
              onError?.(error);
            } finally {
              setIsCommitting(false);
            }
          }}
        />
      );
      break;
    case 'mainInstructor':
      fieldName = [dataIndex, 'userId'];
      initialFieldName = fieldName;
      inputNode = (
        <CustomInstructorSelect
          type={inputType}
          taskData={record}
          options={instructorOptions}
          fieldsPermissions={fieldsPermissions}
        />
      );
      break;
    case 'assistantInstructor':
      fieldName = [dataIndex, 'userId'];
      initialFieldName = fieldName;
      inputNode = (
        <CustomInstructorSelect
          type={inputType}
          taskData={record}
          options={instructorOptions}
          fieldsPermissions={fieldsPermissions}
        />
      );
      break;
    case 'transportCompany':
      fieldName = [dataIndex, 'id'];
      initialFieldName = fieldName;
      inputNode = (
        <Select
          placeholder={`Selecione ${title}`}
          optionFilterProp="label"
          dropdownStyle={{ borderRadius: 16, zIndex: 9999 }}
          options={transportCompanyOptions}
          showSearch
          style={{ width: '100%' }}
          onChange={() => {
            // Força re-renderização usando setFieldsValue
            setTimeout(() => {
              const currentValues = formTaskList.getFieldsValue();
              formTaskList.setFieldsValue(currentValues);
            }, 0);
          }}
        />
      );
      break;
    case 'driverList': {
      const formValues = formTaskList.getFieldsValue();
      const transportCompanyId = formValues.list?.[record.tablePageIndex]?.transportCompany?.id;

      const currentTransportCompany = transportCompanyOptions?.find(
        (company) => company.id === transportCompanyId
      );

      inputNode = (
        <DriverVehicleCellEditor
          driverOptions={driverOptions}
          vehicleOptions={vehicleOptions}
          transportCompany={currentTransportCompany}
          fieldsPermissions={fieldsPermissions}
          disabled={!editing}
        />
      );
      break;
    }
    case 'reasonNoBilling':
      fieldName = [dataIndex, 'id'];
      initialFieldName = fieldName;
      inputNode = (
        <ReasonNoBillingEditor
          title={title}
          options={reasonNoBillingOptions}
          disabled={isCommitting}
          onCommit={
            openForAllRoles && onCommitOpenField
              ? async (reasonNoBilling) => {
                  setIsCommitting(true);
                  try {
                    return await onCommitOpenField(record, { reasonNoBilling });
                  } finally {
                    setIsCommitting(false);
                  }
                }
              : null
          }
        />
      );
      break;
    case 'invoiceIssuer':
      fieldName = [dataIndex, 'id'];
      initialFieldName = fieldName;
      inputNode = (
        <Select
          placeholder={`Selecione ${title}`}
          optionFilterProp="label"
          dropdownStyle={{ borderRadius: 16, zIndex: 9999 }}
          options={invoiceIssuersOptions}
          showSearch
          style={{ width: '100%' }}
        />
      );
      break;
    default:
      inputNode = <strong>INPUT TYPE NÃO DEFINIDO: ({inputType})</strong>;
      break;
  }

  const initialValue = getCellInitialValue(record, dataIndex, initialFieldName, inputType);

  const handleDataPropagation = () => {
    propagateCellValue(
      formTaskList,
      record,
      dataIndex,
      inputType,
      isCustomField,
      resolvedCustomName
    );
  };

  return (
    <td {...restProps}>
      {editing ? (
        <div style={{ display: 'flex' }}>
          <Form.Item
            name={[record.tablePageIndex, ...fieldName]}
            style={{
              margin: 0,
              width: inputType === 'checkbox' || inputType === 'fileUpload' ? 'auto' : '100%',
            }}
            rules={[additionalRules]}
            {...(inputType === 'checkbox' && { valuePropName: 'checked' })}
            {...(initialValue !== null && { initialValue })}
          >
            {inputNode}
          </Form.Item>
          {inputType !== 'fileUpload' && showPropagate && (
            <Tooltip title="Propagar valor para outras linhas selecionadas">
              <ForkOutlined style={{ marginLeft: 5 }} onClick={handleDataPropagation} />
            </Tooltip>
          )}
        </div>
      ) : (
        children
      )}
    </td>
  );
}
